// extracted by mini-css-extract-plugin
export default {"calendar_ready":"calendar_ready__ed344e02"};